<template>
  <div class="wrapper">
    <Menu />
    <Header title="Üyelik Aktivasyonu" hideMore />
    <div
      class="body-area pt70"
      style="    height: -webkit-fill-available; display: flex; flex: 1; align-items: center; justify-content: center; flex-direction: column; padding: 0px 25px"
    >
      <h2
        class="text-center fc-1"
        :class="status == 200 ? 'fc-1' : 'fc-2'"
        style="margin-bottom: 20px"
      >{{message}}</h2>

      <input type="text" v-model="email" class="form-input" placeholder="E-Posta" />

      <input type="text" v-model="token" class="form-input" placeholder="Doğrulama Kodu" />

      <button
        class="opak-button fc-2"
        @click="$router.push({name: 'Login'})"
        v-if="status == 200"
      >Giriş Yap</button>
      <button class="confirm-button" @click="activate" v-if="status != 200">Aktive Et</button>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "Activate",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      message: null,
      status: 0,
      email: this.$route.query.email,
      token: this.$route.query.code
    };
  },
  methods: {
    activate() {
      this.message = "Üyeliğiniz Aktive Ediliyor...";
      var data = new FormData();
      data.append("email", this.email);
      data.append("confirmation_code", this.token);
      axios.post("uyelik/aktive-et", data).then(res => {
        this.message = res.data.message;
        this.status = res.data.status;
      });
    }
  },
  beforeMount() {
    if (this.email == undefined || this.token == undefined) {
    } else {
      this.message = "Üyeliğiniz Aktive Ediliyor...";
      var data = new FormData();
      data.append("email", this.email);
      data.append("confirmation_code", this.token);
      axios.post("uyelik/aktive-et", data).then(res => {
        this.message = res.data.message;
        this.status = res.data.status;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Activate.vue